import {
  Box,
  Button,
  chakra,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { dimensionsKeys } from "../../../../../../utils";
import { CategoryGridHeaderRow, CategoryModalGridItemsSection } from "./index";

function CategoryModal({ modalData, formData, attributesOrder, isOpen, onClose, onSubmit, getEmptyRow, mapRow }) {
  const { t } = useTranslation("translation");
  const { editData, columnHeaders, modalHeaderItemsType, organizationStructure } = modalData;
  const { handleSubmit } = formData;

  // ESG-3894: prepend one dimension column per active dimension when the
  // questionnaire has an organizationStructure (same pattern as Scope 1/2).
  const activeDimensionKeys = organizationStructure
    ? dimensionsKeys.filter(dimKey => organizationStructure.dimensions[dimKey])
    : [];
  const dimensionHeaders = activeDimensionKeys.map(dimKey => organizationStructure.dimensions[dimKey].name);
  const mergedColumnHeaders = [...dimensionHeaders, ...columnHeaders];
  const totalColumns = attributesOrder.length + activeDimensionKeys.length;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        borderRadius="lg"
        w="fit-content"
        maxW="calc(100vw - 32px)"
        minW={{ base: "auto", md: "640px" }}
      >
        <chakra.form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader fontSize="18px" fontWeight="700" color="darkTeal">
            {t(`organizationQuestionnaire.${editData ? "editItemModalHeader" : "addItemsModalHeader"}`,
              { type: modalHeaderItemsType })
            }
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box borderWidth="1px" borderRadius="md" overflow="hidden" bg="white">
              <Grid
                templateColumns={`repeat(${totalColumns * 2 + (editData ? 0 : 1)}, auto)`}
                minWidth="700"
                maxHeight="400"
                overflow="auto"
                sx={{
                  "&::-webkit-scrollbar": { width: "6px" },
                  "&::-webkit-scrollbar-thumb": { bg: "transparent", borderRadius: "full" },
                  "&:hover::-webkit-scrollbar-thumb": { bg: "gray.300" },
                  scrollbarWidth: "thin",
                  scrollbarColor: "transparent transparent",
                  "&:hover": { scrollbarColor: "var(--chakra-colors-gray-300) transparent" },
                }}
              >
                <CategoryGridHeaderRow
                  columnHeaders={mergedColumnHeaders}
                />
                <CategoryModalGridItemsSection
                  modalData={modalData}
                  formData={formData}
                  numberOfColumns={totalColumns}
                  getEmptyRow={getEmptyRow}
                  mapRow={mapRow}
                />
              </Grid>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose} borderRadius="full">
              {t("buttons.close")}
            </Button>
            <Button bg="lime" color="pureBlack" borderRadius="full" _hover={{ bg: "limeShade.300" }} type="submit">
              {t("buttons.save")}
            </Button>
          </ModalFooter>
        </chakra.form>
      </ModalContent>
    </Modal>
  );
}

export default CategoryModal;
